import { connect } from "react-redux";
import injectIntl from "../../../../../common/helpers/injectIntl";
import { setPlanMeta } from "../../../../store/plan/actions";
import { post } from "../../../../actions/general";

import Rhythm from "./Rhythm";

export default connect(null, { setPlanMeta, post })(injectIntl(Rhythm));
